/**
 * Canonical recommendation context implementation.
 *
 * This is the source of truth for recommendation context consumers.
 * Consumers should import via `@atlassian/post-office-context/message-lifecycle`.
 */
import { type Context, createContext, useContext } from 'react';
import React from 'react';

import AnalyticsContext from '@atlaskit/analytics-next/AnalyticsContext';

export type RecommendationContext = {
	sessionId?: string;
	entityId?: string;
	itemFeatureSetId?: string;
};

export const RecommendationContext: Context<RecommendationContext> =
	createContext<RecommendationContext>({
		sessionId: undefined,
		entityId: undefined,
		itemFeatureSetId: undefined,
	});

export const RecommendationProvider = ({
	value,
	children,
}: React.PropsWithChildren<{ value: RecommendationContext }>): JSX.Element => {
	return (
		<RecommendationContext.Provider value={value}>
			<AnalyticsContext data={value}>{children}</AnalyticsContext>
		</RecommendationContext.Provider>
	);
};

export const useRecommendationContext = (): RecommendationContext =>
	useContext(RecommendationContext);
